var map = {
	"./de-DE.json": "6922",
	"./en-GB.json": "282d",
	"./en-US.json": "e0e1",
	"./es-ES.json": "4109",
	"./fr-FR.json": "cfe4",
	"./ka-GE.json": "813e",
	"./machine-translated.json": "df91",
	"./no-NO.json": "53d2",
	"./no-TR.json": "921a",
	"./sl-SL.json": "4e37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6828";